import type { ReactNode } from 'react';
import { cn } from '@reflex/ui/lib/utils';

interface MetricBlockProps {
  value: ReactNode;
  caption: string;
  valueClassName?: string;
  className?: string;
}

export function MetricBlock({ value, caption, valueClassName, className }: MetricBlockProps) {
  return (
    <div className={cn('text-center', className)}>
      <div className={cn('text-lg font-semibold tabular-nums', valueClassName)}>{value}</div>
      <div className="text-2xs text-muted-foreground">{caption}</div>
    </div>
  );
}
